import Fullscreen from './fullscreen.vue'
export default Fullscreen



// WEBPACK FOOTER //
// ./src/view/main/components/fullscreen/index.js